import { domainUrl } from '../constants';

export const API_GET_SIZE_GROUPS = `${domainUrl}size-groups`;
export const API_SIZE_GROUP = `${domainUrl}size-groups/{id}`;

export const API_GET_SIZES = `${domainUrl}sizes`;
export const API_SIZE = `${domainUrl}sizes/{id}`;
